import { render, staticRenderFns } from "./AuditoriaAlunos.vue?vue&type=template&id=a9503320"
import script from "./AuditoriaAlunos.vue?vue&type=script&lang=js"
export * from "./AuditoriaAlunos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports